import common from './common';
import login from './login';
import menu from './menu';
import navbar from './navbar';
import employee from './employee';
import company from './company';
import department from './department';
import error from './error';
import account from './account';
import interviewSettings from './interviewSettings';
import interviewProcess from './interviewProcess';
import interviewChannel from './interviewChannel';
import interview from './interview';
import job from './job';
import calendar from './calendar';
import candidate from './candidate';
import jobPreview from './jobPreview';
import notify from './notify';
import dataSummary from './dataSummary';
import chat from './chat';

export default {
  common,
  navbar,
  login,
  menu,
  employee,
  company,
  department,
  error,
  account,
  interviewSettings,
  interviewProcess,
  interviewChannel,
  job,
  interview,
  calendar,
  candidate,
  jobPreview,
  notify,
  dataSummary,
  chat,
};
